import * as Scrivito from "scrivito";

function CategorySelection({
  categories,
  content,
  currentValues,
  attributeName,
  lang,
}) {
  const updateTags = (obj, cValues, aName, tag) => {
    const values = {};
    if (cValues.indexOf(tag) === -1) {
      values[aName] = [...cValues, tag];
    } else {
      values[aName] = cValues.filter((item) => item !== tag);
    }
    obj.update(values);
  };

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <>
      <div className="row category_selection">
        <div className="col-md-12">
          <div className="attribute_category_item">
            <div
              className="scrivito_detail_label"
              data-item-id="attribute.category"
            >
              <div>
                <i className="scrivito_icon scrivito_icon_auto"></i>
                <span>Category</span>
              </div>
            </div>
            <div className="item_content">
              <div className="multienum_attribute_component">
                <ul className="enum_attribute scrivito_multi">
                  {[...new Set(categories)].map((item, index) => {
                    if (!item.key) {
                      return null;
                    }
                    const className =
                      currentValues.indexOf(item.key) !== -1
                        ? "enum_attribute_active"
                        : "";
                    return (
                      <li
                        key={`${item.key}_${index}`}
                        className={className}
                        onClick={() => {
                          updateTags(
                            content,
                            currentValues,
                            attributeName,
                            item.key
                          );
                        }}
                      >
                        {item[lang]}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Scrivito.connect(CategorySelection);
